// @systeme: interface
// Les écrans et leurs chemins. Le garde-fou R6 vérifie que tout lien pointe ici.
import { Navigate, Route, Routes } from 'react-router';
import { Coquille, ZonePublique } from './composants/Coquille';
import { Appels } from './ecrans/admin/Appels';
import { Chiffres } from './ecrans/admin/Chiffres';
import { Foyers } from './ecrans/admin/Foyers';
import { Journal } from './ecrans/admin/Journal';
import { Retours } from './ecrans/admin/Retours';
import { Support } from './ecrans/admin/Support';
import { Verification } from './ecrans/admin/Verification';
import { CoquilleAdmin } from './ecrans/admin/CoquilleAdmin';
import { Formules } from './ecrans/admin/Formules';
import { Interrupteurs } from './ecrans/admin/Interrupteurs';
import { Prompts } from './ecrans/admin/Prompts';
import { Reglages } from './ecrans/admin/Reglages';
import { Aujourdhui } from './ecrans/Aujourdhui';
import { AVenir } from './ecrans/AVenir';
import { Boite } from './ecrans/Boite';
import { ListeDetail } from './ecrans/ListeDetail';
import { ListePartagee } from './ecrans/ListePartagee';
import { Listes } from './ecrans/Listes';
import { Notes } from './ecrans/Notes';
import { QuiFaitQuoi } from './ecrans/QuiFaitQuoi';
import { Rejoindre } from './ecrans/Rejoindre';
import { NouvelleRecurrence } from './ecrans/NouvelleRecurrence';
import { NouvellePreparation } from './ecrans/NouvellePreparation';
import { Preparation } from './ecrans/Preparation';
import { Preparations } from './ecrans/Preparations';
import { Recurrences } from './ecrans/Recurrences';
import { ConfirmationCourriel } from './ecrans/ConfirmationCourriel';
import { Connexion } from './ecrans/Connexion';
import { Inscription } from './ecrans/Inscription';
import { Juridique } from './ecrans/Juridique';
import { MaSemaine } from './ecrans/MaSemaine';
import { Moi } from './ecrans/Moi';
import { MotDePasseOublie } from './ecrans/MotDePasseOublie';
import { Reinitialisation } from './ecrans/Reinitialisation';

export function RoutesApplication() {
  return (
    <Routes>
      <Route element={<ZonePublique />}>
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
        <Route path="/reinitialisation" element={<Reinitialisation />} />
      </Route>
      <Route element={<Coquille />}>
        <Route path="/" element={<Aujourdhui />} />
        <Route path="/boite" element={<Boite />} />
        <Route path="/a-venir" element={<AVenir />} />
        <Route path="/a-venir/recurrences" element={<Recurrences />} />
        <Route path="/a-venir/recurrences/nouvelle" element={<NouvelleRecurrence />} />
        <Route path="/a-venir/preparations" element={<Preparations />} />
        <Route path="/a-venir/preparations/nouvelle" element={<NouvellePreparation />} />
        <Route path="/a-venir/preparations/:id" element={<Preparation />} />
        <Route path="/listes" element={<Listes />} />
        <Route path="/listes/:id" element={<ListeDetail />} />
        <Route path="/notes" element={<Notes />} />
        <Route path="/moi" element={<Moi />} />
        <Route path="/moi/qui-fait-quoi" element={<QuiFaitQuoi />} />
        <Route path="/moi/ma-semaine" element={<MaSemaine />} />
      </Route>
      {/* L'espace de Juliette : admin seulement, le serveur vérifie aussi. */}
      <Route element={<CoquilleAdmin />}>
        <Route path="/admin" element={<Chiffres />} />
        <Route path="/admin/reglages" element={<Reglages />} />
        <Route path="/admin/plans" element={<Formules />} />
        <Route path="/admin/prompts" element={<Prompts />} />
        <Route path="/admin/interrupteurs" element={<Interrupteurs />} />
        <Route path="/admin/foyers" element={<Foyers />} />
        <Route path="/admin/retours" element={<Retours />} />
        <Route path="/admin/support" element={<Support />} />
        <Route path="/admin/appels" element={<Appels />} />
        <Route path="/admin/journal" element={<Journal />} />
        <Route path="/admin/verification" element={<Verification />} />
      </Route>
      {/* Une liste ouverte par son lien : ni session, ni navigation. */}
      <Route path="/liste/:jeton" element={<ListePartagee />} />
      {/* Le lien du courriel de bienvenue : avec ou sans session. */}
      <Route path="/verification" element={<ConfirmationCourriel />} />
      {/* Les textes légaux : avec ou sans compte. Un écran par texte, pour que R6 suive les liens. */}
      <Route path="/juridique/cgu" element={<Juridique cle="cgu" />} />
      <Route path="/juridique/cgv" element={<Juridique cle="cgv" />} />
      <Route path="/juridique/confidentialite" element={<Juridique cle="confidentialite" />} />
      {/* Un lien d'invitation : avec ou sans compte. */}
      <Route path="/rejoindre/:jeton" element={<Rejoindre />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
